module.exports = __webpack_public_path__ + "img/report-9.2810c6b7.jpg";